import React from "react";
import ProductArticle from "./ProductArticle";

function ArticleList(props) {
  const { articles } = props;
  return (
    <div>
      {articles.map(article => (
        <ProductArticle key={article.id} article={article} />
      ))}
    </div>
  );
}

export default ArticleList;
